<template>
  <button type="button" class="btn btn-success" @click="open">
    <font-awesome-icon icon="plus" />下載清關點貨明細表
  </button>
  <!--Edit Modal -->
  <PrimeDialog
    v-model:visible="isShowDialog"
    header="下載清關點貨明細表"
    :modal="true"
    class="p-fluid"
    :style="{ width: '80vw', 'min-height': '100vh' }"
    :position="position"
  >
     

<div class="row">
    <div class="col-3">
      <my-date-single
        v-model="date1"
        :label="'日期from'"
      ></my-date-single>
    </div>
    <div class="col-3">
      <my-date-single
        v-model="date2"
        :label="'日期to'"
      ></my-date-single>
    </div>
    <div class="col-2">
      <div class="btn-group" role="group">
        <button type="button" class="btn btn-success" @click="download">
          <font-awesome-icon icon="search" />Search
        </button>
      </div>
    </div>
</div>


    <p v-html="message" style="color: red"></p>
  </PrimeDialog>
</template>

<script>
 
import service from "../service/Appservice";
export default {
  props: {
    msg: String,
  },
  data() {
    return {
      data: null,
      date1:null,
      date2:null,
      isShowDialog: false,
      excelData: [],
      uploadData: [],
      message: "",
    };
  },
  inject: ["params"],
  computed: {
    user() {
      return this.$store.state.user;
    },
    agentNo() {
      return this.$store.state.user?.agentNo;
    },
    getHeader() {
      return this.excelData.slice(0, 1);
    },
    getBody() {
      return this.excelData.slice(1);
    },
  },
  service: null,
  created() {
    this.service = new service();
  },

  methods: {
    format_date_yyyymmdd(mdate){
    const date=new Date(mdate)
    const Year = date.getFullYear();
    const Month =
      date.getMonth() + 1 > 9 ? date.getMonth() + 1 : "0" + (date.getMonth() + 1);
    const Day = date.getDate() > 9 ? date.getDate() : "0" + date.getDate();
    let Format_string = "";
    Format_string = Year + "/" + Month + "/" + Day;
    return Format_string;
  },
     ////////搜尋/////////////////////////////////////
      download() {
        
        let d1 = this.format_date_yyyymmdd(this.date1)
        let d2 = this.format_date_yyyymmdd(this.date2)

      this.service.downloadStatusClear(d1,d2)
        .then((response) => {

          console.log('download')
          console.log(response)
           
          let filename='派件分區明細表.xlsx'
          var blob = new Blob([response.data], {type: 'application/vnd.ms-excel;charset=utf-8'})
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(blob, filename)
          } else {
            var downloadElement = document.createElement('a')
            var href = window.URL.createObjectURL(blob) // 建立下載的連結
            downloadElement.href = href
            downloadElement.download = filename // 下載後檔名
            document.body.appendChild(downloadElement)
            downloadElement.click() // 點選下載
            document.body.removeChild(downloadElement) // 下載完成移除元素
            window.URL.revokeObjectURL(href) // 釋放掉blob物件
          }

        });
    },
    ////////搜尋/////////////////////////////////////
    open() {
      this.isShowDialog = true;
    },
  },
};
</script>
 